<template>
    <div>
        <template v-if="!loading">
            <b-row>
                <div class="col-12">
                    <b-card>
                        <b-card-title title-tag="h5" :title="`Bookings for ${marshal.name}`"></b-card-title>
                        <b-card-body>
                            <div id="bookings-table"></div>
                        </b-card-body>
                    </b-card>
                </div>
            </b-row>
        </template>
    </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
    props: {
        marshalRaw: {
            default: false,
        },
    },
    data() {
        return {
            bookings: false,
            marshal: false,
            loading: false,
            table: false,
        }
    },
    computed: {
        bookingGroups() {
            if (!this.bookings) {
                return [];
            }
            // Convert bookings to an array if it's an object
            const bookingsArray = typeof this.bookings === 'object' ? Object.values(this.bookings) : this.bookings;

            // Iterator over the array and add the year and month to each booking based on the start_time field
            bookingsArray.forEach(booking => {
                const date = new Date(booking.booking.game.start_time);
                booking.year = date.getFullYear();
                booking.month = (date.getMonth() + 1).toString().padStart(2, '0');
                // Week of the month (1-5)
                booking.week = Math.ceil(date.getDate() / 7);

                if (booking.booking.state === 'arrived') {
                    booking.booking.show = true;
                } else {
                    booking.booking.show = false;
                }
            });

            // Reorder the array by year then month then week then by booking.member.forename (alphabetically) and booking.member.surname (alphabetically)
            bookingsArray.sort((a, b) => {
                if (a.year !== b.year) {
                    return a.year - b.year;
                }
                if (a.month !== b.month) {
                    return a.month - b.month;
                }
                if (a.week !== b.week) {
                    return a.week - b.week;
                }
                if (a.booking.member.forename !== b.booking.member.forename) {
                    return a.booking.member.forename.localeCompare(b.booking.member.forename);
                }
                return a.booking.member.surname.localeCompare(b.booking.member.surname);
            });

            return bookingsArray;     
        },
    },
    methods: {
        buildTable() {
            this.table = new Tabulator('#bookings-table', {
                data: this.bookingGroups,
                groupBy: ['year', 'month', 'week'],
                groupStartOpen:[false, false],
                groupHeader:[
                    function(value, count, data, group){
                        return `Year ${value} (${count} bookings)`;
                    },
                    function(value, count, data, group){
                        // Convert the value which is the month number into a string with the month name and also display the count of bookings
                        return `${moment(value, 'MM').format('MMMM')} (${count} bookings)`;                        
                    },
                    function(value, count, data, group){
                        const show = data.filter(booking => booking.booking.show).length;
                        const noShow = data.filter(booking => !booking.booking.show).length;
                        return `Week ${value} (${count} bookings) - Show: ${show} No Show: ${noShow}`;
                    },
                ],
                placeholder: 'No bookings found',
                layout: 'fitColumns',
                columns: [
                    {title: 'Member', field: 'booking.member.forename', formatter: (cell) => {
                        return `${cell.getData().booking.member.forename} ${cell.getData().booking.member.surname}`;
                    }},
                    {title: 'Game', field: 'booking.game.title', formatter: (cell) => {
                        // If the game has a name then return {name} ({start_time}) otherwise return {start_time} localised from UTC to Europe/London
                        return cell.getData().booking.game.title ? `${cell.getData().booking.game.title} (${moment(cell.getData().booking.game.start_time).format('DD/MM/YYYY HH:mm')})` : moment(cell.getData().booking.game.start_time).tz('Europe/London').format('DD/MM/YYYY HH:mm');
                    }},
                    {title: 'Show/No Show', field: 'booking.show', formatter: 'tickCross'},
                ],
            });
        },
        init() {
            axios.get(this.$routes.route('marshal.bookings', {user: this.marshal.id}))
                .then(response => {
                    console.log('Bookings', response.data)
                    this.bookings = response.data;
                }).catch(error => {
                    console.log('Here', error);
                }).finally(() => {
                    this.loading = false;
                    setTimeout(this.buildTable, 100);
                });
        },
    },
    mounted() {
        this.marshal = this.marshalRaw;
        this.loading = true;
        this.init();
    },
}
</script>